import styled, { css } from "styled-components";
import * as React from "react";

import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { Text } from "src/library/components/Text";
import { formatPrice } from "src/core/prices/utils";

import { IOrderDeliveryCharge } from "../api/orders.api";

interface DeliveryChargeLineProps {
  deliveryCharge: IOrderDeliveryCharge;
}
export const DeliveryChargeLine: React.FC<DeliveryChargeLineProps> = ({ deliveryCharge }) => {
  return (
    <StyledDeliveryCharge>
      <div className="delivery-charge-inner">
        <div className="delivery-charge-left">
          <div className="icon-wrapper">
            <Icon
              icon={Icons.VAN}
              size={45}
            />
          </div>

          <Text as="h3">
            {deliveryCharge.product?.description || "Delivery Charge"}
          </Text>
        </div>

        <Text
          className="delivery-charge-price"
          weight="bold"
          fontSize="h4"
        >
          {formatPrice(deliveryCharge.price, 2)}
        </Text>
      </div>
    </StyledDeliveryCharge>
  );
};

const StyledDeliveryCharge = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.padding.md};
    background: ${theme.colors.lightestGrey};

    .delivery-charge-inner {
      width: 100%;
      height: 100px;
      display: flex;
      background: ${theme.colors.white};
      align-items: center;
      justify-content: space-between;
      margin: auto;
      padding-right: ${theme.spacing.padding.md};
    }

    .delivery-charge-left {
      display: flex;
      align-items: center;
    }

    .icon-wrapper {
      background: ${theme.colors.lightGrey};
      height: 100px;
      width: 100px;
      display: flex;
      align-items: center; 
      justify-content: center;
      margin-right: ${theme.spacing.margins.md};
    }

    h3 {
      margin-bottom: 0;
    }

  `}
`;
